<template>
  <ul-select v-model="lang" @change="change" placeholder="请选择">
    <ul-option
      v-for="item in languages"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
    </ul-option>
  </ul-select>
</template>

<script>
import { languages } from '@/config/i18n.js'
import cookies from '@/utils/cookie'
export default {
  name: 'component-change-language',
  data () {
    return {
      languages: languages,
      lang: 'zh',
    }
  },
  created () {
    if (cookies.get('lang')) {
      this.lang = cookies.get('lang')
    }
  },
  methods: {
    change () {
      console.log(this.lang)
      cookies.set("lang", this.lang)
      location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>